import { numberFormat, defaultLocales } from "locale"

export default function parse(value, locale = defaultLocales[0]) {
  if (typeof value === "number") {
    return value
  }

  if (!value) {
    return undefined
  }

  const format = numberFormat(locale)
  const clean = value.replace(format.cleanPattern, "")
  const normalized = clean.replace(format.decimal, ".")

  return parseFloat(normalized)
}



// WEBPACK FOOTER //
// ../ui-kit/src/components/ui-Number/parse.js